import { useEffect, useRef } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { toast } from "react-toastify"
import { checkSession, SESSION_EXPIRED_TOAST } from "../../utils/sessionCookie"
import { parseRoutePathToSlugs } from "../../utils/routeCityPrefill"
import { clearAllPulpitClientStorage } from "../../utils/clientStorage"

/**
 * Wraps /routes/* pages. Redirects to home with toast if no valid session.
 * Passes routePrefill so home form can fill from/to from the URL.
 */
export default function SessionRouteGuard({ children }) {
  const navigate = useNavigate()
  const { routePath } = useParams()
  const toastShown = useRef(false)

  useEffect(() => {
    if (!checkSession()) {
      if (!toastShown.current) {
        toast.warning(SESSION_EXPIRED_TOAST)
        toastShown.current = true
      }
      clearAllPulpitClientStorage({ keepRecentSearches: true })
      const parsed = parseRoutePathToSlugs(routePath || "")
      navigate("/", {
        replace: true,
        state: parsed ? { routePrefill: parsed } : undefined,
      })
    }
  }, [navigate, routePath])

  if (!checkSession()) {
    return null
  }

  return children
}
